import Image from 'next/image'

import Flex from '@totallymoney/ui/components/Flex'

import backgroundQuotationScaleLevel40 from '@images/background-quotation-scaleLevel40.png'

const UnscoredCategoryPageBackgroundTextureExpertSection = () => (
    <Flex
        alignItems="flex-end"
        position="absolute"
        top={['160px', 'space60']}
        right={['space30', 'space30', '5%', '10%']}
        aria-hidden="true"
    >
        <Image
            src={backgroundQuotationScaleLevel40}
            alt=""
            placeholder="empty"
            sizes="100vw"
            quality={60}
            priority={false}
        />
    </Flex>
)

export default UnscoredCategoryPageBackgroundTextureExpertSection
